import { render } from "./OutputFile.vue?vue&type=template&id=540c52e8"
import script from "./OutputFile.vue?vue&type=script&lang=js"
export * from "./OutputFile.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__